export enum AzureTransactionCode {
  AzureRenewalSuccess,
  AzureRenewalFailed
}
